<template>
    <fieldset>
        <legend>
            <label>
                <input type="radio" name="shippingSource" @change="sourceChanged" checked> Alle verfügbaren Adressen ({{ count }})
            </label>
        </legend>
        <div v-if="enabled">
            <div class="checkbox">
                <label>
                    <input type="checkbox" name="addNewAddress" v-model="addNewAddress">
                    <span>
                        Neue Lieferadresse
                    </span>
                </label>
            </div>
            <div v-if="! addNewAddress">
                <select2 v-if="addressbook.length" :options="addressbookData" v-model="selectedAddress"></select2>
            </div>
            <div v-else>
                <new-address v-model="address" :countries="countries" ref="newAddress"></new-address>                
            </div>
        </div>
    </fieldset>
</template>

<script>

import {clone} from "lodash";
import Select2 from "../../../../select2/Select2.vue";
import NewAddress  from './NewAddress';

export default {

    components: {
        Select2,
        NewAddress
    },

    props: {
        user: {
            required: true,
            default: null
        },
        countries: {
            required: true,
            default: []
        },
        addressbook: {
            required: true,
            default: []
        }
    },

    data() {
        return {
            enabled: true,
            address: clone(this.user),
            addNewAddress: false,
            loadingAddressBook: false,
            selectedAddress: 0,
            newAddress: {
                company: '',
                name: '',
                street: '',
                city: '',
                zip: '',
                country: '',
                countryName: '',
            },
        }
    },

    computed: {
        
        addressbookData() {
            return this.addressbook.map((address, i) => {
                return {
                    'id': i,
                    'text': `${i + 1}. ${address.company}, ${address.street}, ${address.zip} ${address.city}, ${address.countryName}`
                }
            });
        },

        count() {
            return this.addressbook.length;
        }

    },

    created() {

        App.event.listen('shipping.source.changed', ({who}) => {
            this.enabled = who == 'all';
            this.emitChange();
        });
        
    },

    methods: {
        
        sourceChanged() {
            App.event.fire('shipping.source.changed', { who: 'all' });
        },

        validate() {
            if(!this.enabled || !this.addNewAddress) {
                return true;
            }
            return (
                this.validField('company') &&
                this.validField('name') &&
                this.validField('street') &&
                this.validField('city') &&
                this.validField('zip') &&
                this.validField('country')
            );
        },

        validField(name) {
            if (name == 'country') {
                return this.address[name] > 0;
            } 

            return this.address[name].length > 0;
        },

        emitChange() {
            if (this.enabled) {
                this.$emit('change', {
                    address: clone(this.address),
                    isNew: this.addNewAddress
                });
            }
        }

    },

    watch: {

        addNewAddress() {
            this.address = this.addNewAddress ? clone(this.newAddress) : clone(this.addressbook).shift();
        },

        selectedAddress() {
            this.address = this.addressbook[this.selectedAddress];
        },

        address: {
            deep: true,
            handler: function() { this.emitChange(); }
        }

    }

}
</script>
